import React, { useState, useEffect } from 'react'
import useAuth from '../../../hooks/useAuth'
import { useRouter } from 'next/router'
import { cn } from '@utils/safeTs'
import MyAccountMenuItem from '../MyAccountMenuItem/MyAccountMenuItem'
import styles from './MyAccountMenu.module.sass'
import { MyAccountMenuItemType } from '@utils/types'


interface Props {
  items?: MyAccountMenuItemType[]
  orientation?: 'vertical' | 'horizontal'
  hideLogout?: boolean
  className?: string
}

const MyAccountMenu = (props: Props) => {

  const { 
    items = [], 
    orientation = 'vertical', 
    hideLogout = false,
    className = undefined,
  } = props

  const [selectedItem, setSelectedItem] = useState(undefined)
  const [clickedSubItem, setClickedSubItem] = useState(undefined)
  const router = useRouter()
  const { Logout } = useAuth()

  const setup = () => {
    items.forEach((item) => (item?.route === router?.route || (item.isSelected ? item.isSelected(router?.route) : false)) && setSelectedItem(item?.key))
    try {
      router?.route.toString().split('/').length > 3 &&
        items?.forEach((item) => {
          // ! console.log(router?.route.toString().split('/').slice(0, -1).join('/'), item?.route)
          // ? Gli item con i subItems non hanno una route
          if (!item?.route) {
            item?.subItems.forEach(
              (subitem) =>
                subitem?.route === router?.route &&
                (setSelectedItem(item?.key), setClickedSubItem(subitem?.key))
            )
          }
        })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setup()
  }, [])

  useEffect(() => {
    setup()
  }, [items])

  return (
    <ul className={cn(styles.root, styles[`root--${orientation}`], className)}>
      {items?.map((item) => (
        <MyAccountMenuItem
          key={item.key}
          item={item}
          orientation={orientation}
          setClickedSubItem={setClickedSubItem}
          selectedItem={selectedItem}
          clickedSubItem={clickedSubItem}
          initOpen={selectedItem === item.key}
          isActive={selectedItem === item.key}
        />
      ))}

      {!hideLogout && (
        <MyAccountMenuItem 
          item={{ key: 'logout', placeholder: 'Logout' }} 
          className={styles.logout}
          onClick={async () => {
            await Logout()
          }} 
        />
      )}
    </ul>
  )
}

export default MyAccountMenu
